import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { jobEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { Job } from '@/types/job';

/**
 * Transitions a job to SCHEDULED status.
 */
export function useScheduleJob() {
  const queryClient = useQueryClient();

  return useApiMutation<Job, string>({
    mutationFn: (id) => apiPost<Job>(operationsClient, jobEndpoints.schedule(id)),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: jobKeys.detail(data.id) });
      toast.success('Job scheduled');
    },
  });
}
